import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react';
import { PropsWithChildren } from 'react';

/**
 * Wraps the app with PostHog's analytics provider and its error boundary.
 * The error boundary acts as a final safety net for any errors that escape
 * the inner application error boundaries, forwarding them to PostHog.
 */
export default function PostHogProviderWithErrorBoundary({ children }: PropsWithChildren) {
  const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

  // Without an API key, PostHogProvider would call posthog.init(undefined) and log a
  // "PostHog was initialized without a token" warning on every page load. Local dev
  // intentionally leaves the key unset (see .env.example), so skip the provider there.
  if (!apiKey) return <>{children}</>;

  return (
    <PostHogProvider
      apiKey={apiKey}
      options={{
        api_host: import.meta.env.VITE_POSTHOG_HOST,
        capture_exceptions: true,
      }}
    >
      <PostHogErrorBoundary>{children}</PostHogErrorBoundary>
    </PostHogProvider>
  );
}
